import React from 'react';
import { createContext, useContext } from 'react';
import type { TranslationKeys } from './TranslationKeys';

export const TranslationContext = createContext<Partial<TranslationKeys> | null>(null);

export const TranslationProvider: React.FC<{ children: React.ReactNode; translations: Partial<TranslationKeys> }> = ({
  children,
  translations,
}) => {
  return <TranslationContext.Provider value={translations}>{children}</TranslationContext.Provider>;
};

export const useTranslation = () => {
  let context = useContext(TranslationContext);

  if (!context) {
    console.warn('useTranslation must be used within a TranslationProvider');
    context = {};
  }

  return context;
};
